// themes.js — обновлённые темы с футуристичным акцентом
export const lightTheme = {
  background: '#f0f4f8',
  text: '#1a1a2e',
  cardBackground: 'rgba(255, 255, 255, 0.7)',
  cardBorder: 'rgba(255, 255, 255, 0.3)',
  buttonBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  buttonHover: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
  accent: '#667eea',
  glass: 'rgba(255, 255, 255, 0.25)',
  shadow: '0 8px 32px rgba(31, 38, 135, 0.15)',
};

export const darkTheme = {
  background: '#0f0f1e',
  text: '#e0e6ff',
  cardBackground: 'rgba(20, 20, 40, 0.6)',
  cardBorder: 'rgba(102, 126, 234, 0.2)',
  buttonBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  buttonHover: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
  accent: '#667eea',
  glass: 'rgba(30, 30, 60, 0.4)',
  shadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
};